// Exact card IDs checked against the English catalogue on 2026-10-16.
// Bounds are [left, top, width, height], normalised to the displayed card.
const modern = [.08, .10, .84, .375];
const xy = [.085, .107, .825, .39];
export const FOIL_EXAMPLES = {
  normal: { id: 'sv03-001', finish: 'Normal', window: modern },
  classic: { id: 'base1-4', finish: 'Holo · Base Set', window: [.108, .118, .786, .398] },
  cosmos: { id: 'swshp-SWSH039', finish: 'Cosmos Holo promo', window: modern },
  vertical: { id: 'swsh1-14', finish: 'Holo · Sword & Shield', window: modern },
  horizontal: { id: 'xy1-26', finish: 'Holo · XY', window: xy },
  reverse: { id: 'sv03-001', finish: 'Reverse Holo · Obsidian Flames', window: modern },
  'reverse-cosmos': { id: 'hgss1-1', finish: 'Reverse Holo · HeartGold SoulSilver', window: [.095, .12, .81, .36], study: 'Cosmos reverse is a material study on a reverse-capable card, not a verified foil pattern for this printing.' },
  crosshatch: { id: 'swsh12.5-001', finish: 'Reverse Holo · Crown Zenith', window: modern, study: 'Crosshatch is a texture study; this card has a reverse printing, but its exact pattern is not reproduced.' },
  pokeball: { id: 'sv08.5-001', finish: 'Poké Ball reverse · Prismatic Evolutions', window: modern },
  masterball: { id: 'sv08.5-002', finish: 'Master Ball reverse · Prismatic Evolutions', window: modern },
  snowflake: { id: 'swsh7-49', finish: 'Holiday Pikachu illustration', window: modern, region: 1, study: 'Snowflake pattern study only. The Holiday Calendar version has a festive stamp; repeated snowflakes are not a reproduction of that stamp.' },
  'cracked-ice': { id: 'swsh4-25', finish: 'Cracked Ice Holo · theme deck Charizard', window: modern, region: 1 },
  confetti: { id: '2022swsh-7', finish: 'Holo · McDonald’s Collection 2022', window: modern },
  mirror: { id: 'hgss1-1', finish: 'Reverse Holo · HeartGold SoulSilver', window: [.095, .12, .81, .36] },
  'full-art': { id: 'swsh12.5-160', finish: 'Full-art secret rare Pikachu' },
  etched: { id: 'swsh12-186', finish: 'Textured alternate-art Lugia V' },
  rainbow: { id: 'sm3-150', finish: 'Rainbow rare Charizard-GX' },
  gold: { id: 'swsh12-215', finish: 'Gold secret rare V Guard Energy' },
  silver: { id: 'xy4-122', finish: 'Silver secret rare Dialga-EX' },
  radiant: { id: 'swsh12.5-020', finish: 'Radiant Charizard' },
  shiny: { id: 'swsh4.5sv-SV107', finish: 'Shiny Charizard VMAX' },
  amazing: { id: 'swsh4-50', finish: 'Amazing Rare Raikou', region: 3, study: 'The illustration extends beyond a normal art window; this study uses a full-surface overlay.' },
  oil: { id: 'swsh12-186', finish: 'Full-art material comparison', study: 'Oil-slick is a concept study, not a claimed finish of this Lugia printing.' },
  lenticular: { id: 'swsh12.5-160', finish: 'Full-art material comparison', study: 'Lenticular is a concept study, not a claimed Pikachu printing or an alternate-view image.' },
};

export const EXAMPLE_IDS = [...new Set(Object.values(FOIL_EXAMPLES).map(example => example.id))];
export const DEFAULT_WINDOW = modern;

export function clampWindow(bounds) {
  const [x, y, width, height] = bounds.map(Number);
  const left = Math.max(0, Math.min(.98, Number.isFinite(x) ? x : modern[0]));
  const top = Math.max(0, Math.min(.98, Number.isFinite(y) ? y : modern[1]));
  return [left, top, Math.max(.02, Math.min(1 - left, Number.isFinite(width) ? width : modern[2])),
    Math.max(.02, Math.min(1 - top, Number.isFinite(height) ? height : modern[3]))];
}

// Repeatable pseudo-random timing: independent phase, speed and orbit per study.
export function foilMotion(id, seconds) {
  let seed = 2166136261;
  for (const character of id) seed = Math.imul(seed ^ character.charCodeAt(0), 16777619) >>> 0;
  const offset = (seed % 10000) / 10000;
  const speed = .65 + ((seed >>> 8) % 1000) / 1000 * .30;
  const phase = seconds * speed + offset * Math.PI * 2;
  return { phase, light: [.5 + Math.sin(phase) * .40, .5 + Math.cos(phase * (.71 + offset * .3) + offset * 4) * .38] };
}
